// extracted by mini-css-extract-plugin
export default {"logo":"footer_logo__0KLOb","text":"footer_text__VVU9o","floating_btn":"footer_floating_btn__h-on2"};